import React from 'react';
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Link from '@mui/material/Link';
import Typography from '@mui/material/Typography';
import LogoIcon from '../../../../images/icons/logo_icon.svg';
import { Link as ReactLink } from 'react-router-dom';
import styles from './Footer.module.scss';

const Footer = () => {
  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <Box
          display={'flex'}
          justifyContent={'space-evenly'}
          alignItems={'center'}
          width={1}
          flexDirection={{ xs: 'column', sm: 'row' }}
        >
          <Box
            display={'flex'}
            component={ReactLink}
            to="/"
            title="Hauscanner"
            width={80}
          >
            <Box component={'img'} src={LogoIcon} height={1} width={0.64} />
          </Box>
          <Box className={styles.linksFooter} display="flex" flexWrap={'wrap'} alignItems={'center'}>
            <Box marginTop={1} marginRight={2}>
              <Link
                underline="none"
                component={ReactLink}
                to="/faq"
                color="text.primary"
                variant={'subtitle2'}
              >
                Preguntas frecuentes sobre Hauscanner
              </Link>
            </Box>
            <Box marginTop={1} marginRight={2}>
              <Link
                underline="none"
                component={ReactLink}
                to="/cookies-politics"
                color="text.primary"
                variant={'subtitle2'}
              >
                Política de Cookies
              </Link>
            </Box>
            <Box marginTop={1} marginRight={2}>
              <Link
                underline="none"
                component={ReactLink}
                to="/data-politics"
                color="text.primary"
                variant={'subtitle2'}
              >
                Políticas de Tratamiento de Datos
              </Link>
            </Box>
            <Box marginTop={1} marginRight={2}>
              <Link
                underline="none"
                component={ReactLink}
                to="/companyTerms"
                color="text.primary"
                variant={'subtitle2'}
              >
                Términos y condiciones
              </Link>
            </Box>
            <Box marginTop={1}>
              <Button
                variant="outlined"
                color="primary"
                component={ReactLink}
                to="/pricing"
                size="small"
              >
                Precios
              </Button>
            </Box>
          </Box>
        </Box>
      </Grid>
      <Grid item xs={12}>
        <Box
          display={'flex'}
          justifyContent={'center'}
          alignItems={'center'}
          width={1}
          flexDirection={{ xs: 'column', sm: 'row' }}
        >
          <Typography
            align={'center'}
            variant={'subtitle2'}
            color="text.secondary"
            gutterBottom
          >
            &copy; 2022 Hauscanner · info@hauscanner.com · Siguenos en:
          </Typography>
          <div className={styles.socialNetworks}>
            <a target="_blank" href="https://twitter.com/hauscanner">
              <i className="fonticons fonticons-twitter" />
            </a>
            <a target="_blank" href="https://www.instagram.com/hauscanner">
              <i className="fonticons fonticons-instagram" />
            </a>
          </div>
        </Box>
        <Typography
          align={'center'}
          variant={'caption'}
          color="text.secondary"
          component={'p'}
        >
          Hauscanner · La casa que buscabas ¡Al mejor precio del mercado!
        </Typography>
      </Grid>
    </Grid>
  );
};

export default Footer;
